(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    const setup = (video) => {
      if (video.dataset.ssReady) return;
      video.dataset.ssReady = '1';

      const mode = video.dataset.ssHeroVideo || 'itse';
      const media = video.closest('.ss-hero__media');
      const hero = video.closest('.ss-hero');

      // Vähemmän liikettä: video ei käynnisty eikä reagoi vieritykseen.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }

      video.muted = true;
      const play = () => {
        const playing = video.play();
        if (playing && typeof playing.catch === 'function') playing.catch(() => {});
        return playing;
      };

      // Kuinka pitkälle osio on vieritetty: 0 sivun alussa, 1 kun osion kuva-alue on lähes kokonaan ohi.
      const progress = () => {
        const box = (media || hero).getBoundingClientRect();
        const top = box.top + window.scrollY;
        const range = Math.max(1, (top + box.height) * 0.7);
        return clamp(window.scrollY / range, 0, 1);
      };

      if (mode === 'kelaus') {
        // Video etenee vierittäessä: sivun alussa ensimmäinen kuva, alaspäin vierittäessä video kulkee eteenpäin.
        video.loop = false;
        video.removeAttribute('autoplay');
        video.pause();

        // iPhone lataa videon vasta, kun se on kerran käynnistetty: käynnistetään ja pysäytetään heti.
        const unlock = () => {
          const playing = video.play();
          if (playing && typeof playing.then === 'function') playing.then(() => video.pause()).catch(() => {});
          else video.pause();
        };
        if (video.readyState < 2) unlock();

        let current = 0;
        let frame = 0;
        const tick = () => {
          frame = 0;
          const duration = video.duration;
          if (!duration || !Number.isFinite(duration)) return;
          const target = progress() * Math.max(0, duration - 0.06);
          current += (target - current) * 0.25;
          if (Math.abs(target - current) < 0.004) current = target;
          if (!video.seeking && Math.abs(video.currentTime - current) > 0.012) video.currentTime = current;
          if (current !== target || video.seeking) frame = window.requestAnimationFrame(tick);
        };
        const kick = () => {
          if (!frame) frame = window.requestAnimationFrame(tick);
        };
        window.addEventListener('scroll', kick, { passive: true });
        window.addEventListener('resize', kick);
        video.addEventListener('loadedmetadata', kick);
        video.addEventListener('seeked', kick);
        kick();
        return;
      }

      // itse ja liuku: video pyörii vain, kun se on näkyvissä.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          (entries) => entries.forEach((entry) => (entry.isIntersecting ? play() : video.pause())),
          { threshold: 0.05 }
        ).observe(video);
      } else {
        play();
      }

      if (mode === 'liuku' && media) {
        let frame = 0;
        const shift = () => {
          frame = 0;
          media.style.setProperty('--ss-hero-shift', `${Math.round(window.scrollY * 0.2)}px`);
        };
        const kick = () => {
          if (!frame) frame = window.requestAnimationFrame(shift);
        };
        window.addEventListener('scroll', kick, { passive: true });
        kick();
      }
    };

    const start = (root) => root.querySelectorAll('video[data-ss-hero-video]').forEach(setup);
    start(document);
    document.addEventListener('shopify:section:load', (event) => start(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-toimitusraja"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Päivittää palkin ostoskorin summan mukaan. Tekstit tulevat sivulta valmiina, tässä vaihdetaan vain summa ja leveys.
    const render = (cart) => {
      if (!cart || typeof cart.total_price !== 'number') return;
      document.querySelectorAll('[data-ss-raja]').forEach((bar) => {
        const limit = Number(bar.dataset.raja);
        if (!limit) return;
        // Jos ostoskorin valuutta on eri kuin palkin, raja ei päde: jätetään palkki ennalleen.
        if (cart.currency && cart.currency !== bar.dataset.valuutta) return;

        const left = Math.max(0, limit - cart.total_price);
        const share = Math.min(100, (cart.total_price / limit) * 100);
        const done = share >= 100;

        const fill = bar.querySelector('.ss-raja__fill');
        const track = bar.querySelector('.ss-raja__track');
        const amount = bar.querySelector('[data-ss-raja-summa]');
        const open = bar.querySelector('[data-ss-raja-kesken]');
        const ready = bar.querySelector('[data-ss-raja-valmis]');

        if (fill) fill.style.width = `${share}%`;
        if (track) track.setAttribute('aria-valuenow', String(Math.round(share)));
        if (amount) {
          try {
            amount.textContent = new Intl.NumberFormat(bar.dataset.kieli || undefined, {
              style: 'currency',
              currency: bar.dataset.valuutta,
            }).format(left / 100);
          } catch (error) {
            amount.textContent = (left / 100).toFixed(2);
          }
        }
        if (open) open.hidden = done;
        if (ready) ready.hidden = !done;
        bar.toggleAttribute('data-valmis', done);
      });
    };

    let timer = 0;
    const refresh = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        if (!document.querySelector('[data-ss-raja]')) return;
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
          .then((response) => response.json())
          .then(render)
          .catch(() => {});
      }, 150);
    };

    // Teema lähettää cart:update-tapahtuman, kun ostoskoriin lisätään tai sitä muutetaan.
    document.addEventListener('cart:update', refresh);
    document.addEventListener('shopify:section:load', refresh);
    window.addEventListener('pageshow', refresh);
    refresh();
  })();

  } catch(e) { console.error(e); }
})();
})();
